import React from "react";
import styles from "./TimelineSidebar.module.css";

export default function TimelineSidebar({ receipts = [], selectedReceipt, onSelectReceipt }) {
  return (
    <aside className={styles.sidebar}>
      {/* 🟦 компенсируем высоту ticksRowLocal из TimelineCanvas */}
      <div className={styles.topSpacer} />

      {receipts.map((r) => {
        const active = selectedReceipt?.id === r.id;
        const color =
          r.status === "Закрыта"
            ? "#16a34a"
            : r.status === "Открыта"
            ? "#2563eb"
            : r.status === "Не доставлено"
            ? "#ef4444"
            : "#6b7280";

        return (
          <div
            key={r.id}
            className={`${styles.row} ${active ? styles.active : ""}`}
            onClick={() => onSelectReceipt?.(r)}
          >
            <span
              className={styles.statusDot}
              style={{ backgroundColor: color }}
              title={r.status}
            />
            <span className={styles.address}>{r.delivery_address || "Без адреса"}</span>
          </div>
        );
      })}
    </aside>
  );
}
